(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.wrappers.validation'
  var templateUrl = require('./tpl/validation.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly')
    ])
    .run(validationWrapperConfig)

  validationWrapperConfig.$inject = ['formlyConfig']
  function validationWrapperConfig (formlyConfig) {
    formlyConfig.setWrapper({
      name: 'validation',
      types: ['input', 'radio'],
      templateUrl: templateUrl
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/wrappers/validation.js